export default __webpack_public_path__ + "static/media/Arrow-straight.374f7cf4.svg";